import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vali

  <span style="color:#85c1dc;">**FI:**</span>
  Valitse

  <span style="color:#85c1dc;">**RU:**</span>
  Выберите
*/
/* @__NO_SIDE_EFFECTS__ */
const m1548 = msg(
  mf`Vali`,
  mf`Valitse`,
  mf`Выберите`,
)

export { m1548 as 'w.module.options_section.choose' }